<template>
  <div class="signin-component">
    <slot>
      <transition v-if="message" name="slide-fade">
        <div :class="messageClass" role="alert">{{ message }}</div>
      </transition>

      <div class="form-group">
        <div class="input-icon">
          <i class="oi oi-envelope-closed"></i>
        </div>
        <input class="form-control" data-cy="email" v-model="email" name="email" type="email" placeholder="Email" />
      </div>

      <div class="form-group">
        <div class="input-icon">
          <i class="oi oi-lock-locked"></i>
        </div>
        <input
          class="form-control"
          data-cy="password"
          v-model="password"
          type="password"
          v-on:keyup.enter="signIn"
          placeholder="Enter password"
        />
      </div>

      <div class="forget-password">
        <div class="text-right">
          <a @click.prevent="$emit('eventForgotPassword')">Forgot your password?</a>
        </div>
      </div>

      <div class="text-center">
        <button
          class="signin-btn btn btn-primary"
          :disabled="shouldDisableSignInButton"
          data-cy="Sign-in"
          @click.prevent="signIn"
        >
          Sign in
        </button>
      </div>

      <div v-if="!hideRegisterButton" class="text-center">
        <button class="register-btn btn btn-outline-primary mt-3" @click.prevent="$emit('eventCreateAccount')">
          <span class="text-muted">Don't have an account?</span> Create one
        </button>
      </div>
    </slot>
  </div>
</template>

<script>
  import getMessageFromApiResponse from './SignInUtil'
  import { messages } from './messages'

  export default {
    name: 'SignIn',
    props: {
      apiResponse: {
        type: Object,
        default: () => new Object()
      },
      messageType: {
        type: String,
        default: null
      },
      defaultMessageClass: {
        type: String,
        default: null
      },
      defaultMessage: {
        type: String,
        default: ''
      },
      hideRegisterButton: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        email: '',
        password: ''
      }
    },
    computed: {
      message() {
        if (this.defaultMessage) return this.defaultMessage
        if (this.messageType) return messages[`${this.messageType}_MESSAGE`]
        return getMessageFromApiResponse(this.apiResponse)
      },
      messageClass() {
        if (this.defaultMessageClass) return this.defaultMessageClass
        if (this.messageType) return messages[`${this.messageType}_CLASS`]
        return 'alert alert-danger'
      },
      shouldDisableSignInButton() {
        return !this.email || !this.password
      }
    },
    methods: {
      signIn() {
        const payload = {
          email: this.email,
          password: this.password
        }
        this.$emit('eventSignIn', payload)
      }
    }
  }
</script>

<style scoped lang="scss">
  .signin-component {
    a {
      font-weight: 500;
      color: #ff8708 !important;
      cursor: pointer;
    }
    .signin-btn {
      width: 300px;
    }
    .register-btn {
      width: 300px;
      font-size: 15px;
      -webkit-font-smoothing: auto;
      .text-muted {
        color: #778598;
      }
      &:hover {
        background-color: #ff8708;
        .text-muted {
          color: white !important;
        }
      }
    }
  }
</style>
